const OFFICIAL_SOURCES = [
  { title: 'UAE Government Emiratisation guidance', url: 'https://u.ae/en/information-and-services/jobs/employment-in-the-private-sector/emiratis-employment-in-private-sector' },
  { title: 'MoHRE awareness guide for new employers', url: 'https://www.mohre.gov.ae/assets/download/c52cad71/Awareness%20Guide%20for%20New%20Employers%20Companies%20-%20EN.pdf.aspx' },
  { title: 'Ministerial Resolution No. 279 of 2022', url: 'https://assets.u.ae/api/public/content/577ab8e214b341f28fba1ecdb812b475?v=f066e6f5' },
  { title: 'Ministerial Resolution No. 455 of 2023', url: 'https://www.mohre.gov.ae/assets/download/a75fda5d/Ministerial%20Resolution%20No.%20455%20of%202023_638945684757690218.pdf.aspx' },
  { title: 'Cabinet Decision No. 43 of 2025', url: 'https://www.mohre.gov.ae/assets/download/5e5d828/Cabinet%20Decision%20No.%2043%20of%202025%20Concerning%20Administrative%20Violations%20and%20Penalties%20Related%20to%20Initiatives%20and%20Programmes%20of%20the%20UAE%20Talent%20Competitiveness%20Council_638945683693487835.pdf.aspx' },
];

export const EMIRATISATION_DISCLAIMER = 'ClockSpotter provides an advisory estimate from information recorded by the employer. Official compliance is determined by MoHRE/Nafis records, valid work permits, WPS salary payments and pension registration. Verify the result in MoHRE systems or with a qualified UAE HR/legal adviser.';

function value(source, camel, pascal, fallback = null) {
  if (!source || typeof source !== 'object') return fallback;
  if (source[camel] !== undefined && source[camel] !== null) return source[camel];
  if (source[pascal] !== undefined && source[pascal] !== null) return source[pascal];
  return fallback;
}

function number(source, camel, pascal, fallback = 0) {
  const parsed = Number(value(source, camel, pascal, fallback));
  return Number.isFinite(parsed) ? parsed : fallback;
}

function nullableNumber(source, camel, pascal, fallback = null) {
  const raw = value(source, camel, pascal, fallback);
  if (raw === null || raw === undefined || raw === '') return null;
  const parsed = Number(raw);
  return Number.isFinite(parsed) ? parsed : null;
}

function nullableBoolean(source, camel, pascal) {
  const result = value(source, camel, pascal, null);
  return result === true ? true : result === false ? false : null;
}

function textValue(source, names, fallback = '') {
  if (!source || typeof source !== 'object') return fallback;
  for (const name of names) {
    if (source[name] !== undefined && source[name] !== null) return String(source[name]);
  }
  return fallback;
}

function rawValue(source, names, fallback = null) {
  if (!source || typeof source !== 'object') return fallback;
  for (const name of names) {
    if (source[name] !== undefined && source[name] !== null) return source[name];
  }
  return fallback;
}

function normalizeIncompleteEmployees(source) {
  return Array.isArray(source) ? source.map((employee) => ({
    employeeId: nullableNumber(employee, 'employeeId', 'EmployeeId'),
    employeeCode: String(value(employee, 'employeeCode', 'EmployeeCode', '')),
    employeeName: String(value(employee, 'employeeName', 'EmployeeName', 'Unnamed employee')),
    missingFields: Array.isArray(value(employee, 'missingFields', 'MissingFields', []))
      ? value(employee, 'missingFields', 'MissingFields', []).map(String) : [],
  })).filter((employee) => employee.employeeId != null) : [];
}

export function normalizeEstablishmentSummary(source = {}) {
  const missingEvidence = value(source, 'missingEvidence', 'MissingEvidence', {});
  const incompleteEmployees = normalizeIncompleteEmployees(value(source, 'incompleteEmployees', 'IncompleteEmployees', []));
  const incompleteEmployeeCount = number(source, 'incompleteEmployeeCount', 'IncompleteEmployeeCount', incompleteEmployees.length);
  const missingSetupFields = value(source, 'missingSetupFields', 'MissingSetupFields', []);
  return {
    visaBranchId: nullableNumber(source, 'visaBranchId', 'VisaBranchId'),
    name: String(value(source, 'name', 'Name', 'Unnamed establishment')),
    emirate: String(value(source, 'emirate', 'Emirate', '')),
    mohreEstablishmentNumber: textValue(source, ['mohreEstablishmentNumber', 'mohReEstablishmentNumber', 'MohreEstablishmentNumber', 'MohReEstablishmentNumber']),
    status: String(value(source, 'status', 'Status', 'NotConfigured')),
    activeEmployeeCount: number(source, 'activeEmployeeCount', 'ActiveEmployeeCount'),
    applicability: String(value(source, 'applicability', 'Applicability', 'Unconfigured')),
    ruleCategory: String(value(source, 'ruleCategory', 'RuleCategory', '')),
    calculatedRate: nullableNumber(source, 'calculatedRate', 'CalculatedRate'),
    calculatedTarget: nullableNumber(source, 'calculatedTarget', 'CalculatedTarget'),
    effectiveTargetCount: nullableNumber(source, 'effectiveTargetCount', 'EffectiveTargetCount', nullableNumber(source, 'targetCount', 'TargetCount')),
    targetSource: String(value(source, 'targetSource', 'TargetSource', 'Calculated')),
    qualifyingCount: number(source, 'qualifyingCount', 'QualifyingCount', number(source, 'qualifyingEmiratiCount', 'QualifyingEmiratiCount')),
    remainingSlots: nullableNumber(source, 'remainingSlots', 'RemainingSlots', nullableNumber(source, 'shortfall', 'Shortfall')),
    skilledWorkerCount: number(source, 'skilledWorkerCount', 'SkilledWorkerCount'),
    missingEvidenceTotal: number(source, 'missingEvidenceTotal', 'MissingEvidenceTotal', number(missingEvidence, 'totalIncompleteEmployees', 'TotalIncompleteEmployees', incompleteEmployeeCount)),
    missingSetupFields: Array.isArray(missingSetupFields) ? missingSetupFields.map(String) : [],
    incompleteEmployees,
    incompleteEmployeeCount,
    thresholdTransition: String(value(source, 'thresholdTransition', 'ThresholdTransition', '')),
    nextDeadline: value(source, 'nextDeadline', 'NextDeadline'),
    daysRemaining: nullableNumber(source, 'daysRemaining', 'DaysRemaining'),
  };
}

export function normalizeEstablishmentSettings(source = {}) {
  return {
    visaBranchId: nullableNumber(source, 'visaBranchId', 'VisaBranchId'),
    name: String(value(source, 'name', 'Name', 'Unnamed establishment')),
    emirate: String(value(source, 'emirate', 'Emirate', '')),
    mohreEstablishmentNumber: textValue(source, ['mohreEstablishmentNumber', 'mohReEstablishmentNumber', 'MohreEstablishmentNumber', 'MohReEstablishmentNumber']),
    activeEmployeeCount: number(source, 'activeEmployeeCount', 'ActiveEmployeeCount'),
    applicability: String(value(source, 'applicability', 'Applicability', 'Unconfigured')),
    ruleCategory: String(value(source, 'ruleCategory', 'RuleCategory', '')),
    targetedEconomicSector: String(value(source, 'targetedEconomicSector', 'TargetedEconomicSector', '')),
    mohreSelectedEstablishment: rawValue(source, ['mohreSelectedEstablishment', 'mohReSelectedEstablishment', 'MohreSelectedEstablishment', 'MohReSelectedEstablishment'], null),
    officialTargetCount: nullableNumber(source, 'officialTargetCount', 'OfficialTargetCount'),
    targetConfirmedAt: value(source, 'targetConfirmedAt', 'TargetConfirmedAt', ''),
    rowVersion: value(source, 'rowVersion', 'RowVersion', null),
    hasSavedSettings: value(source, 'hasSavedSettings', 'HasSavedSettings', false) === true,
    calculatedRate: nullableNumber(source, 'calculatedRate', 'CalculatedRate'),
    calculatedTarget: nullableNumber(source, 'calculatedTarget', 'CalculatedTarget'),
    effectiveTargetCount: nullableNumber(source, 'effectiveTargetCount', 'EffectiveTargetCount'),
    targetSource: String(value(source, 'targetSource', 'TargetSource', 'Calculated')),
    thresholdTransition: String(value(source, 'thresholdTransition', 'ThresholdTransition', '')),
    saveError: '',
    saving: false,
  };
}

export function bannerPresentation(status) {
  const presentations = {
    NotConfigured: { visible: true, severity: 'amber', title: 'Emiratisation information required', message: 'Confirm whether MoHRE Emiratisation rules apply to this establishment.' },
    DataIncomplete: { visible: true, severity: 'amber', title: 'Emiratisation evidence incomplete', message: 'Complete the employer target and employee permit, pension, WPS and skill evidence.' },
    DeadlineApproaching: { visible: true, severity: 'amber', title: 'Emiratisation deadline approaching', message: 'Review the confirmed target and evidence before the next reporting deadline.' },
    PolicyReviewRequired: { visible: true, severity: 'amber', title: 'Emiratisation policy review required', message: 'The stored policy period has ended. Verify the latest MoHRE requirements before relying on this estimate.' },
    ActionRequired: { visible: true, severity: 'red', title: 'Emiratisation action required', message: 'Complete recorded evidence indicates a shortfall against the applicable advisory or official MoHRE target.' },
    OnTrack: { visible: false, severity: 'none', title: '', message: '' },
    NotApplicable: { visible: false, severity: 'none', title: '', message: '' },
  };
  return presentations[status] || presentations.NotConfigured;
}

export function normalizeComplianceSummary(source = {}) {
  const status = String(value(source, 'status', 'Status', 'NotConfigured'));
  const missingEvidence = value(source, 'missingEvidence', 'MissingEvidence', {});
  const missingSetupFields = value(source, 'missingSetupFields', 'MissingSetupFields', []);
  const incompleteEmployees = value(source, 'incompleteEmployees', 'IncompleteEmployees', []);
  const establishments = value(source, 'establishments', 'Establishments', []);
  const unassignedEmployees = value(source, 'unassignedEmployees', 'UnassignedEmployees', []);
  const sourceLinks = Array.isArray(value(source, 'officialSources', 'OfficialSources', []))
    ? value(source, 'officialSources', 'OfficialSources', []).map((item) => ({
      title: String(value(item, 'title', 'Title', 'Official source')),
      url: String(value(item, 'url', 'Url', '')),
    })).filter((item) => OFFICIAL_SOURCES.some((sourceItem) => sourceItem.url === item.url))
    : [];
  return {
    status,
    applicability: String(value(source, 'applicability', 'Applicability', 'Unconfigured')),
    ruleCategory: String(value(source, 'ruleCategory', 'RuleCategory', '50Plus')),
    targetCount: nullableNumber(source, 'targetCount', 'TargetCount', nullableNumber(source, 'effectiveTargetCount', 'EffectiveTargetCount', nullableNumber(source, 'officialTargetCount', 'OfficialTargetCount'))),
    qualifyingCount: number(source, 'qualifyingCount', 'QualifyingCount', number(source, 'qualifyingEmiratiCount', 'QualifyingEmiratiCount')),
    remainingSlots: nullableNumber(source, 'remainingSlots', 'RemainingSlots', nullableNumber(source, 'shortfall', 'Shortfall')),
    skilledWorkerCount: number(source, 'skilledWorkerCount', 'SkilledWorkerCount'),
    missingEvidenceTotal: number(source, 'missingEvidenceTotal', 'MissingEvidenceTotal', number(missingEvidence, 'totalIncompleteEmployees', 'TotalIncompleteEmployees')),
    missingPermitCount: number(source, 'missingPermitCount', 'MissingPermitCount', number(missingEvidence, 'missingWorkPermit', 'MissingWorkPermit')),
    missingPensionCount: number(source, 'missingPensionCount', 'MissingPensionCount', number(missingEvidence, 'missingPensionRegistration', 'MissingPensionRegistration')),
    missingWpsCount: number(source, 'missingWpsCount', 'MissingWpsCount', number(missingEvidence, 'missingWpsPayment', 'MissingWpsPayment')),
    missingSkillCount: number(source, 'missingSkillCount', 'MissingSkillCount', number(missingEvidence, 'missingSkillLevel', 'MissingSkillLevel')),
    belowMinimumWpsAmountCount: number(source, 'belowMinimumWpsAmountCount', 'BelowMinimumWpsAmountCount', number(missingEvidence, 'belowMinimumWpsAmount', 'BelowMinimumWpsAmount')),
    missingSetupFields: Array.isArray(missingSetupFields) ? missingSetupFields.map(String) : [],
    hasMissingInformation: value(source, 'hasMissingInformation', 'HasMissingInformation', false) === true,
    missingInformationCount: number(source, 'missingInformationCount', 'MissingInformationCount'),
    incompleteEmployees: normalizeIncompleteEmployees(incompleteEmployees),
    incompleteEmployeeCount: number(source, 'incompleteEmployeeCount', 'IncompleteEmployeeCount'),
    incompleteEmployeesTruncated: value(source, 'incompleteEmployeesTruncated', 'IncompleteEmployeesTruncated', false) === true,
    nextDeadline: value(source, 'nextDeadline', 'NextDeadline'),
    daysRemaining: number(source, 'daysRemaining', 'DaysRemaining'),
    estimatedExposure: nullableNumber(source, 'estimatedExposure', 'EstimatedExposure', nullableNumber(source, 'estimatedContributionAed', 'EstimatedContributionAed')),
    estimatedExposureFormula: String(value(source, 'estimatedExposureFormula', 'EstimatedExposureFormula', value(source, 'estimatedContributionFormula', 'EstimatedContributionFormula', ''))),
    policyVersion: String(value(source, 'policyVersion', 'PolicyVersion', '')),
    lastReviewedDate: value(source, 'lastReviewedDate', 'LastReviewedDate', value(source, 'policyLastReviewedDate', 'PolicyLastReviewedDate')),
    disclaimer: String(value(source, 'disclaimer', 'Disclaimer', EMIRATISATION_DISCLAIMER)),
    officialSources: sourceLinks.length ? sourceLinks : OFFICIAL_SOURCES,
    establishments: Array.isArray(establishments) ? establishments.map(normalizeEstablishmentSummary) : [],
    unassignedEmployeeCount: number(source, 'unassignedEmployeeCount', 'UnassignedEmployeeCount'),
    unassignedEmployees: normalizeIncompleteEmployees(unassignedEmployees),
  };
}

export function normalizeEmiratisationSettings(source = {}) {
  const rawSuggestions = value(source, 'setupSuggestions', 'SetupSuggestions', {});
  const establishments = value(rawSuggestions, 'establishments', 'Establishments', []);
  const establishmentSettings = value(source, 'establishments', 'Establishments', []);
  return {
    applicability: String(value(source, 'applicability', 'Applicability', 'Unconfigured')),
    ruleCategory: String(value(source, 'ruleCategory', 'RuleCategory', '50Plus')),
    targetedEconomicSector: String(value(source, 'targetedEconomicSector', 'TargetedEconomicSector', '')),
    mohreSelectedEstablishment: nullableBoolean(source, 'mohreSelectedEstablishment', 'MohreSelectedEstablishment'),
    officialTargetCount: value(source, 'officialTargetCount', 'OfficialTargetCount', null),
    targetConfirmedAt: value(source, 'targetConfirmedAt', 'TargetConfirmedAt', ''),
    rowVersion: value(source, 'rowVersion', 'RowVersion', null),
    hasSavedSettings: value(source, 'hasSavedSettings', 'HasSavedSettings', false) === true,
    isConfigured: value(source, 'isConfigured', 'IsConfigured', false) === true,
    setupSuggestions: {
      profileCompanySize: nullableNumber(rawSuggestions, 'profileCompanySize', 'ProfileCompanySize'),
      activeEmployeeCount: number(rawSuggestions, 'activeEmployeeCount', 'ActiveEmployeeCount'),
      profileIndustryType: String(value(rawSuggestions, 'profileIndustryType', 'ProfileIndustryType', '')),
      suggestedTargetedEconomicSector: String(value(rawSuggestions, 'suggestedTargetedEconomicSector', 'SuggestedTargetedEconomicSector', '')),
      suggestedRuleCategory: value(rawSuggestions, 'suggestedRuleCategory', 'SuggestedRuleCategory', null),
      suggestedApplicability: value(rawSuggestions, 'suggestedApplicability', 'SuggestedApplicability', null),
      requiresMohreSelectionConfirmation: value(rawSuggestions, 'requiresMohreSelectionConfirmation', 'RequiresMohreSelectionConfirmation', false) === true,
      establishments: Array.isArray(establishments) ? establishments.map((item) => ({
        visaBranchId: nullableNumber(item, 'visaBranchId', 'VisaBranchId'),
        name: String(value(item, 'name', 'Name', 'Unnamed establishment')),
        emirate: String(value(item, 'emirate', 'Emirate', '')),
        mohreEstablishmentNumber: String(value(item, 'mohreEstablishmentNumber', 'MohreEstablishmentNumber', '')),
      })) : [],
    },
    establishments: Array.isArray(establishmentSettings) ? establishmentSettings.map(normalizeEstablishmentSettings) : [],
  };
}

export function settingsPayload(settings) {
  return {
    ...(settings.visaBranchId == null ? {} : { visaBranchId: Number(settings.visaBranchId) }),
    applicability: settings.applicability,
    ruleCategory: settings.applicability === 'Covered' ? settings.ruleCategory : null,
    targetedEconomicSector: settings.applicability === 'Covered' ? String(settings.targetedEconomicSector || '').trim() || null : null,
    mohreSelectedEstablishment: settings.applicability === 'Covered' && settings.ruleCategory === 'Selected20To49' ? settings.mohreSelectedEstablishment === true : false,
    officialTargetCount: settings.applicability === 'Covered' && settings.officialTargetCount !== '' && settings.officialTargetCount != null ? Number(settings.officialTargetCount) : null,
    targetConfirmedAt: settings.applicability === 'Covered' ? settings.targetConfirmedAt || null : null,
    rowVersion: settings.rowVersion || null,
  };
}

export function updateRuleCategoryDraft(settings) {
  settings.officialTargetCount = null;
  settings.mohreSelectedEstablishment = settings.ruleCategory === 'Selected20To49' ? null : false;
  return settings;
}

export function updateMohreSelectionDraft(settings) {
  settings.officialTargetCount = settings.ruleCategory === 'Selected20To49' && settings.mohreSelectedEstablishment === true ? 2 : null;
  return settings;
}

export function normalizeClassification(source = {}) {
  const rawSuggestions = value(source, 'profileSuggestions', 'ProfileSuggestions', {});
  const missingFields = value(source, 'missingFields', 'MissingFields', []);
  const nationalitySource = String(value(source, 'nationalitySource', 'NationalitySource', ''));
  const pensionSource = String(value(source, 'pensionSource', 'PensionSource', ''));
  const uaeNationalStatus = String(rawValue(source, ['effectiveUaeNationalStatus', 'EffectiveUaeNationalStatus', 'uaeNationalStatus', 'UaeNationalStatus'], 'Unknown'));
  const provenanceSources = [nationalitySource, pensionSource].map((item) => item.toLowerCase());
  const isEmployeeRecordSource = (item) => ['employeerecord', 'verifiedemployeerecord'].includes(item);
  const usesEmployeeRecord = !provenanceSources.includes('explicit')
    && isEmployeeRecordSource(provenanceSources[0])
    && (uaeNationalStatus !== 'Yes' || isEmployeeRecordSource(provenanceSources[1]));
  const requestedEmployeeRecord = nullableBoolean(source, 'useVerifiedEmployeeRecord', 'UseVerifiedEmployeeRecord');
  return {
    employeeId: number(source, 'employeeId', 'EmployeeId', null),
    employeeCode: String(value(source, 'employeeCode', 'EmployeeCode', '')),
    employeeName: String(value(source, 'employeeName', 'EmployeeName', 'Unnamed employee')),
    jobTitle: String(value(source, 'jobTitle', 'JobTitle', 'Not recorded')),
    currentCompensation: value(source, 'currentCompensation', 'CurrentCompensation', null),
    compensationCurrency: String(value(source, 'compensationCurrency', 'CompensationCurrency', 'AED')),
    visaBranchId: nullableNumber(source, 'visaBranchId', 'VisaBranchId'),
    visaBranchName: String(value(source, 'visaBranchName', 'VisaBranchName', '')),
    mohreEstablishmentNumber: textValue(source, ['mohreEstablishmentNumber', 'mohReEstablishmentNumber', 'MohreEstablishmentNumber', 'MohReEstablishmentNumber']),
    uaeNationalStatus,
    mohreSkillLevel: value(source, 'mohreSkillLevel', 'MohreSkillLevel', null),
    hasValidWorkPermit: nullableBoolean(source, 'hasValidWorkPermit', 'HasValidWorkPermit'),
    hasPensionRegistration: rawValue(source, ['effectiveHasPensionRegistration', 'EffectiveHasPensionRegistration', 'hasPensionRegistration', 'HasPensionRegistration'], null),
    nationalitySource,
    pensionSource,
    useVerifiedEmployeeRecord: requestedEmployeeRecord == null ? usesEmployeeRecord : requestedEmployeeRecord && !provenanceSources.includes('explicit'),
    hasWpsPayment: nullableBoolean(source, 'hasWpsPayment', 'HasWpsPayment'),
    latestWpsPaidMonth: value(source, 'latestWpsPaidMonth', 'LatestWpsPaidMonth', ''),
    latestWpsPaidAmount: value(source, 'latestWpsPaidAmount', 'LatestWpsPaidAmount', null),
    verifiedAt: value(source, 'verifiedAt', 'VerifiedAt', ''),
    rowVersion: value(source, 'rowVersion', 'RowVersion', null),
    missingFields: Array.isArray(missingFields) ? missingFields.map(String) : [],
    isEvidenceComplete: value(source, 'isEvidenceComplete', 'IsEvidenceComplete', false) === true,
    hasEvidence: value(source, 'hasEvidence', 'HasEvidence', false) === true,
    profileSuggestionAvailable: nullableBoolean(source, 'profileSuggestionAvailable', 'ProfileSuggestionAvailable'),
    profileSuggestions: {
      nationalityCategory: String(value(rawSuggestions, 'nationalityCategory', 'NationalityCategory', 'Unknown')),
      pensionStatus: String(value(rawSuggestions, 'pensionStatus', 'PensionStatus', 'Unknown')),
      hrClassificationVerified: value(rawSuggestions, 'hrClassificationVerified', 'HrClassificationVerified', false) === true,
      suggestedUaeNationalStatus: value(rawSuggestions, 'suggestedUaeNationalStatus', 'SuggestedUaeNationalStatus', null),
      suggestedHasPensionRegistration: nullableBoolean(rawSuggestions, 'suggestedHasPensionRegistration', 'SuggestedHasPensionRegistration'),
    },
  };
}

export function normalizeClassificationPage(source = {}) {
  const rawItems = Array.isArray(source) ? source : value(source, 'items', 'Items', []);
  const items = Array.isArray(rawItems) ? rawItems.map(normalizeClassification) : [];
  return {
    items,
    pageIndex: number(source, 'pageIndex', 'PageIndex', 1),
    pageSize: number(source, 'pageSize', 'PageSize', items.length || 20),
    totalItems: number(source, 'totalItems', 'TotalItems', items.length),
  };
}

export function classificationPayload(employee) {
  return {
    employeeId: employee.employeeId,
    uaeNationalStatus: employee.uaeNationalStatus,
    mohreSkillLevel: employee.mohreSkillLevel !== '' && employee.mohreSkillLevel != null ? Number(employee.mohreSkillLevel) : null,
    hasValidWorkPermit: employee.uaeNationalStatus === 'Yes' ? employee.hasValidWorkPermit : null,
    hasPensionRegistration: employee.uaeNationalStatus === 'Yes' ? employee.hasPensionRegistration : null,
    hasWpsPayment: employee.uaeNationalStatus === 'Yes' ? employee.hasWpsPayment : null,
    latestWpsPaidMonth: employee.uaeNationalStatus === 'Yes' && employee.hasWpsPayment ? employee.latestWpsPaidMonth || null : null,
    latestWpsPaidAmount: employee.uaeNationalStatus === 'Yes' && employee.hasWpsPayment && employee.latestWpsPaidAmount !== '' && employee.latestWpsPaidAmount != null ? Number(employee.latestWpsPaidAmount) : null,
    verifiedAt: employee.uaeNationalStatus !== 'Unknown' ? employee.verifiedAt || null : null,
    useVerifiedEmployeeRecord: employee.useVerifiedEmployeeRecord === true,
    rowVersion: employee.rowVersion || null,
  };
}

export { OFFICIAL_SOURCES };
